import { useBreakpointValue } from '@chakra-ui/react';
import * as React from 'react';
import Button from '~/components/Button';

const ModalClearFiltersButton = (props) => {
  const isMobileView = useBreakpointValue({ base: true, md: false });

  return (
    <Button
      colorScheme="error"
      fontSize="md"
      letterSpacing={0}
      variant="ghost"
      textTransform="none"
      fontWeight="normal"
      {...props}
    >
      {`Clear${isMobileView ? ' All Filters' : ''}`}
    </Button>
  );
};

export default ModalClearFiltersButton;
